import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedDefaultRetailer } from 'components/KBQSelect'

const initialState: SelectedDefaultRetailer[] = []
const defaultSelectedRetailerKBQOptionsSlices = createSlice({
  name: 'defaultSelectedRetailerKBQOptions',
  initialState,
  reducers: {
    setDefaultSelectedPurchasedRetailer(state, action: PayloadAction<SelectedDefaultRetailer>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    removeSelectedPurchasedRetailer(state, action: PayloadAction<{ id: string }>) {
      return state.filter(({ id }) => id !== action.payload.id)
    },
  },
})

export const { setDefaultSelectedPurchasedRetailer, removeSelectedPurchasedRetailer } =
  defaultSelectedRetailerKBQOptionsSlices.actions

export default defaultSelectedRetailerKBQOptionsSlices.reducer
